import React, { useEffect, useState } from 'react'
import { Breadcrumb, Table } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { fetchSingleSaloon } from '../../../redux/action/saloons/single-saloon'
import MainLoading from '../../../utils/MainLoading'
import SmallLoading from '../../../utils/SmallLoading'
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle'
import DashboardContent from '../../dashboardWrapper/DashboardContent'
import Wrapper from '../../dashboardWrapper/Wrapper'
import CreateStall from './createStall/CreateStall'
import moment from "moment-jalaali";
import './style.scss'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

const DashboardSaloon = (props) => {
    const {t} = useTranslation();
    let lang = localStorage.getItem("lang")
    const [stall , setStall] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const dispatch = useDispatch()
    const saloon = useSelector(state => state.singleSaloon)

    useEffect(() => {
        dispatch(fetchSingleSaloon(props.match.params.id))
    }, [forceUpdate])

    const handleCreateNewStall = () => {
        setStall(true)
        window.scrollTo(0, 900)
    }

    const hideCreateNewStall = () => {
        setStall(false)
        setForceUpdate(1)
    }

    return (
        <Wrapper>
            <DashboardContent>
                <Breadcrumb className='dashboardSaloonBreadcrumb'>
                    <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/dashboard/saloons" }} style={{textDecoration: 'none'}}>{t("dashboard_nav_saloons")}</Breadcrumb.Item>
                    <Breadcrumb.Item active>{saloon ? saloon.single_saloon.name: "" }</Breadcrumb.Item>
                </Breadcrumb>
                <DashboardMainTitle> {t("saloon details")} </DashboardMainTitle>
                {saloon.loading ? 
                    <MainLoading />
                :
                    <div className='dashboardSaloon'>
                        <div className='dashboardSaloonItem'><h6>{t("saloon name")} : </h6>{saloon ? <h1> {saloon.single_saloon.name} </h1> : <SmallLoading />}</div>
                        <div className='dashboardSaloonItem'><h6>{t("saloon created date")}: </h6>
                            {saloon.single_saloon.created_at ? 
                            <h1> 
                                {lang === 'en' ?
                                    saloon.single_saloon.created_at.substr(11, 5)+'-'+saloon.single_saloon.created_at.substr(0, 10)
                                :
                                    saloon.single_saloon.created_at.substr(11, 5)+'-'+moment(saloon.single_saloon.created_at.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')
                                }
                            </h1> 
                            : 
                                <SmallLoading />
                            }
                        </div>

                        {saloon.single_saloon.users &&
                            saloon.single_saloon.users.length ?  
                            <div>
                                <h6>{t("companies")} : </h6>
                                <Table responsive bordered>
                                    <thead>
                                        <tr>
                                            <th>{t("title")}</th>
                                            <th>{t("CEO name")}</th>
                                            <th>{t("view counts")}</th>
                                            <th>{t("situation")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {saloon.single_saloon.users.map(item => (
                                            <tr key={item.id}>
                                                <td>{item.title}</td>
                                                <td>{item.manager_name}</td>
                                                <td>{item.view_count}</td>
                                                <td>{item.is_block === 0 ? "غرفه بلاک نشده است" : "غرفه بلاک شده است"}</td>
                                            </tr>
                                        )) }
                                    </tbody>
                                </Table>
                            </div>
                        :
                        <div className='dashboardSaloonItem'><h6>{t("companies")} : </h6><h1>{t("No company has been created yet")}</h1></div>
                        }
                    </div>
                }
                
                <div className="col-12 create_btn my-5 d-flex justify-content-end">
                    <button className="btn btn-success" onClick={handleCreateNewStall}> {t("create new company")} <i className="fa fa-plus"></i></button>
                </div>

                {stall ? 
                    <div><CreateStall id={props.match.params.id}  hide={hideCreateNewStall}/></div>
                :
                    ''
                }
            </DashboardContent>
        </Wrapper>
    )
}

export default DashboardSaloon
